var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
// Tracks in-flight requests so concurrent calls for the same patient share one HTTP request.
const inFlightRequests = new Map();
/**
 * Triggers backend to fetch/cache patient resources needed by the screener.
 *
 * Backend contract:
 * - 201 Created: resources were newly fetched/cached.
 * - 200 OK: resources already existed for the patient (no-op).
 * Both are 2xx and treated identically as success; the endpoint never returns 409.
 *
 * Concurrent calls for the same patientId are de-duplicated: they share a single
 * in-flight request. The entry is cleared once settled, so a later call (or a
 * retry after failure) issues a fresh request.
 *
 * @throws ApiError if request fails (handled by interceptor)
 */
export const fetchPatientResources = (req) => __awaiter(void 0, void 0, void 0, function* () {
    const existing = inFlightRequests.get(req.patientId);
    if (existing) {
        return existing;
    }
    const request = performFetch(req).finally(() => {
        inFlightRequests.delete(req.patientId);
    });
    inFlightRequests.set(req.patientId, request);
    return request;
});
const performFetch = (req) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post('/screener/patients/resources', Object.assign({ patientId: req.patientId }, (req.tenantId ? { tenantId: req.tenantId } : {})));
    return response.data;
});
